import React, {useState,useEffect} from 'react';
import {Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import DropImage from './DropImage';
import ColInput from './ColInput';
import Toast from './Toast';
import {Inc,Owner,Book} from './Inc';
import {Tools} from './Tools';
import BottomButtons from './BottomButtons';
import Ajax from './Ajax';
import Loading from './Loading';

interface Props {
    owner:Owner,
    book:Book,
    photoIds:number[],
    change(book:Book,photo_ids?:number[]):void,
    close():void,
}

//let errors:string[] = [];
let newImgs:{ [key: string]: string; } = {};

const BookInputPrice = (props:Props)=> {
    Ajax.setEditorId(props.owner.owner_id);
    const classes = useStyles();
    const defPhotoIds:number[] = [];
	const defaultErrors = {"notice":"","price":""};
    const [states,setStates] = useState({
        book: Inc.defaultBook(),
		errors:defaultErrors,
        photo_ids:defPhotoIds,
        numPhotos:0,
        toast:"",
        notFound: false,
        isLoading: false,
    });
    //const [numPhotos,setNumPhotos] = useState(3);
	const changeText = (name: keyof Book) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if( value==="" ){
            addError("notice", value, true);
		} else if( value.length>2000 ){
			addError("notice", value, true);
		} else {
            addError("notice", value, false);
        }
        //change( name , value );
    };
    const change = (name:keyof Book,value:string)=>{
        if( name==="price" || name==="num_limit" ){
            if( value!=="" ){
                const v = parseInt(Tools.toHan(value));
                if( v || v===0 ){
                    setStates({...states,"book":{...states.book,[name]:v}});
                }
            } else {
                setStates({...states,"book":{...states.book,[name]:0}});
            }
        } else {
            setStates({...states,"book":{...states.book,[name]:value}});
        }
    }
    const changeImage = (id:string,src:string)=>{
        newImgs[ id ] = src;
        if( states.numPhotos<10 ){
            let empty = false;
            for( let i=1 ; i<=states.numPhotos ; i++ ){
                const key = "photo" + String(i);
                let value = "dummy";
                if( key===id ){
                    value = src;
                } else if( newImgs[key] ){
                    value = newImgs[key];
                } else if( !states.photo_ids[i-1] || states.photo_ids[i-1]===0 ){
                    //empty = true;
                    value = "";
                }
                if( value==="" ){
                    empty = true;
                }
                //console.log( key , states.photo_ids[i-1] , newImgs[key] );
            }
            if(!empty){
                setStates({...states,numPhotos:states.numPhotos+1});    
            }
        }
        //console.log(states.numPhotos+1);
        //if( Object.keys(newImgs).length===states.numPhotos && states.numPhotos<10 ){
            //setStates({...states,numPhotos:states.numPhotos+1});
        //}
    }
	const addError = (name:keyof Book, value:string, isError:boolean)=>{
		if( name==='notice' ){
			if( isError ){
				let error = '入力してください';
				if(states.book.notice.length>2000) {
					error = '文字数が多すぎます';
				}
				setStates({...states,book:{...states.book,notice:value},errors:{...states.errors,notice:error}});
			} else {
				setStates({...states,book:{...states.book,notice:value},errors:{...states.errors,notice:''}});
			}
		}
	}

    const validate = ()=>{
		let num = 0;
		const errors = defaultErrors;
        if( !states.book.notice || states.book.notice==="" ){
            errors["notice"] = "入力してください";
            num++;
        } else if( states.book.notice.length>2000 ){
            errors["notice"] = "2000文字以内にしてください";
            num++;
        }

		let maxPrice = 10000;
		if( props.owner.high_flag==="1" ){
			maxPrice = 200000;
		}
		if( !states.book.price || states.book.price<100 ){
			num++;
		} else if(states.book.price>maxPrice ){
			num++;
		}
	
        if( num>0 ){
			console.log("toast!");
            setStates({ ...states, errors:errors, toast:"入力に不備があります"});
        } else {
            setStates({ ...states, errors:errors, isLoading:true});
            send();
        }
    }	
    const send = ()=>{
		console.log({
            item_id:props.book.item_id,
            notice:states.book.notice,
            price:states.book.price,
            num_limit:states.book.num_limit,
            perform_time_id:states.book.perform_time_id,
            perform_member_id:states.book.perform_member_id,
            perform_admit_id:states.book.perform_admit_id,
            tax_inc:states.book.tax_inc,
            new_imgs:newImgs,
        });
        Ajax.send("book/updatec",{
            item_id:props.book.item_id,
            notice:states.book.notice,
            price:states.book.price,
            num_limit:states.book.num_limit,
            perform_time_id:states.book.perform_time_id,
            perform_member_id:states.book.perform_member_id,
            perform_admit_id:states.book.perform_admit_id,
            tax_inc:states.book.tax_inc,
            new_imgs:newImgs,
        },(res:any)=>{
			console.log(res);
            if( res.ok ){
                props.change({...states.book,price:res.price},res.photo_ids);
            } else {
                setStates({...states,toast:"エラー"});
            }
        });
    }
    const closeToast = ()=>{
        setStates({...states,toast:""});
	}

    useEffect( ()=>{
        window.scrollTo(0,0);
        newImgs = {};
        if( props.book.book_id>0 ){
            let price = props.book.price;
            if( props.book.price_notax>0 ){
                price = props.book.price_notax;
            }
            if( price<100 ){
                price = 100;
            }
            let numPhotos = props.photoIds.length;
            if( numPhotos < states.numPhotos ){
                numPhotos = states.numPhotos;
            }
            numPhotos++;
            if( numPhotos>10 ){
                numPhotos=10;
            }
            setStates({...states,book:{...props.book,price:price},photo_ids:props.photoIds,numPhotos:numPhotos});
        }
    },[]);

    if( states.notFound ){
        return (
            <Redirect to="/"/>
        );
    }

    let photo_ids:number[] = [];
    //if( states.book.book_id>0 ){
        for( let i=0 ; i<states.numPhotos ; i++ ){
            if( states.photo_ids[i] ){
                photo_ids.push( states.photo_ids[i] );
            } else {
                photo_ids.push(0);
            }
        }
    //}

    let helperPrice = "100円以上";
    let maxPrice = 10000;
    if( props.owner.high_flag==="1" ){
        helperPrice = "100円以上200,000円以下";
        maxPrice = 200000;
    } else {
        helperPrice = "100円以上10,000円以下";
    }

    //console.log(states.book);

    return (
        <div id="book_input_base" className={classes.modalConfirm}>
            <h3 className="bookEditor"><span>C</span>価格と販売情報</h3>
            <Grid container spacing={2} style={{marginTop:"1em"}}>
                <Grid item xs={12} sm={12}>
                    <FormControl className={classes.formControl} fullWidth={true} error={states.errors.notice!==''}>
                        <FormLabel component="label" className={classes.formLabel}>紹介文<span className="formRequired">必須</span></FormLabel>
                        <TextField
                            id="notice"
                            fullWidth
                            multiline
                            rows="4"
                            value={states.book.notice}
                            onChange={changeText('notice')}
                            className={classes.textfield}
                            margin="normal"
                            variant="outlined"
                        />
                        <div className="hint">あらすじ・説明・注意事項など、自由に入力して下さい</div>
                        {states.errors.notice!=='' &&
                        <FormHelperText>{states.errors.notice}</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={3} sm={2} md={2}>
                    <ColInput name="価格" value={states.book.tax_inc} change={change} id="tax_inc" list={Inc.taxs} required type="select"/>
                </Grid>
                <Grid item xs={9} sm={4} md={4}>
                    <ColInput name="" value={String(states.book.price)} change={change} id="price" minRange={100} maxRange={maxPrice} helper={helperPrice} type="text" endAdornment="円"/>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    <ColInput name="試し読みページ数" value={String(states.book.num_limit)} change={change} id="num_limit" minRange={0} maxRange={100} helper="" type="text" endAdornment="ぺージ"/>
                </Grid>
                <Grid item xs={6} sm={4} md={4}>
                    <ColInput name="上演時間の目安" value={states.book.perform_time_id} change={change} id="perform_time_id" list={Inc.performTimes} required type="select"/>
                </Grid>
                <Grid item xs={6} sm={4} md={4}>
                    <ColInput name="役者人数の目安" value={states.book.perform_member_id} change={change} id="perform_member_id" list={Inc.performMembers} required type="select"/>
                </Grid>
                <Grid item xs={6} sm={4} md={4}>
                    <ColInput name="上演許可" value={states.book.perform_admit_id} change={change} id="perform_admit_id" list={Inc.performAdmits} required type="select"/>
                </Grid>
            </Grid>
            <FormControl fullWidth={true} style={{margin:"1em 0"}}>
                <FormLabel component="label">上演写真・宣伝写真など（10枚以内）</FormLabel>
                <Grid container spacing={2} style={{marginTop:"0.25em"}}>
                    {photo_ids.map((img_id:number,index:number)=>{
                        const key = "photo"+String(index+1);
                        const name = "追加画像" + String(index+1);
                        //console.log( key , props.owner.owner_id , img_id );
                        return (
                            <Grid key={key} item xs={6} sm={4}>
                                <DropImage owner_id={props.owner.owner_id} img_id={img_id} data={newImgs[key]} name={name} id={key} change={changeImage}/>
                            </Grid>
                        );
                    })}
                </Grid>
            </FormControl>
			<BottomButtons button1='この内容で保存' onClick1={validate} button2='閉じる' onClick2={props.close}/>
            <Toast close={closeToast} mes={states.toast}/>
            <Loading isLoading={states.isLoading}/>
        </div>
	);
}

export default BookInputPrice;
